import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// GridStack CSS
import 'gridstack/dist/gridstack.min.css';

// Global styles
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
